// Toast utility to trigger toasts from anywhere in the app
// This will be used by the ToastContainer component to manage state

let toastContainer = null;

export const setToastContainer = (container) => {
  toastContainer = container;
};

export const showToast = (message, duration = 5000) => {
  if (toastContainer && typeof toastContainer.addToast === 'function') {
    return toastContainer.addToast(message, duration);
  }
  console.warn('Toast container not initialized');
  return null;
};

export const showSuccessToast = (message, duration = 5000) => {
  return showToast(message, duration);
};

export const showErrorToast = (message, duration = 5000) => {
  return showToast(message, duration);
};

export const showInfoToast = (message, duration = 5000) => {
  return showToast(message, duration);
};

// Expose on window for e2e tests
if (typeof window !== 'undefined') {
  window.showToast = showToast;
}
